<template>
  <span style="display: inline-block;">
    <!-- <div style="display:flex;flex-wrap: wrap;align-items: flex-end;">
      <div style="margin-bottom:5px;margin-right:5px;">{{ $t('zhichiDeliveryCountry') }}:</div>
      <div v-for="(Countries, index) in countryList" style="margin-right:5px;margin-bottom:5px;">
        {{ $t(Countries.simple_speech) }} <span v-if="index > 0 && index < countryList.length-1" style="margin-left:2px;">,</span>
      </div>
    </div> -->
    <div style="display: flex;flex-wrap: wrap;">
      <div v-if="postage && postage.post_fee" style="display: flex;align-items: baseline;height:22px;">
        <div style="height:22px;display: flex;align-items: center;margin-right: 5px;"> {{ $t('ShippingFee') }}:</div>
        <div style="height:22px;display: flex;align-items: center;" class="postFeeContext">
          <!--  (currentCountry ? currentCountry.name : '') + ' ' + (currentProvice ?
          currentProvice.countries_library_nodes_name : '') + ' ' + -->
          {{ $n(postage.post_fee.post_fee,
          'currency') }}
          <!-- <SfIcon @click="changeEdit" icon="marker_fill" color="#00f" size="1.2rem" viewBox="0 0 24 24" :coverage="1"
        style="display: block;margin-left: 5px;" /> -->
        </div>
      </div>
    </div>
    <div style="display: flex;" >
      <SfSelect :label="''" v-model="countryCode" name="country" class="countrySelect" style="padding-top:0.8rem;"
        @input="($event) => changeCounry($event, 1)">
        <SfSelectOption v-for="country in countryList" :key="country.key" :value="country.simple_speech">{{
          $t(country.simple_speech)
          }}
        </SfSelectOption>
      </SfSelect>
      <SfSelect style="margin-left: 10px;padding-top:0.8rem;" :label="''" v-model="proviceCode" name="province"
        class="countrySelect" @input="($event) => changeProvince($event)">
        <SfSelectOption v-for="province in provinceList" :key="province.key"
          :value="province.countries_library_nodes_name">{{ province.countries_library_nodes_name }}
        </SfSelectOption>
      </SfSelect>
    </div>
    <div v-if="!postage || !postage.post_fee">
      <div >
        <div>
          <span style="display: flex;" v-if="goodPostErr">
            <SfIcon @click="changeEdit" icon="error" color="#f00" size="1.2rem" viewBox="0 0 24 24" :coverage="1"
              style="margin-right: 5px;" />{{ goodPostErr }}
          </span>
        </div>
        <!-- <SfIcon @click="changeEdit" icon="marker_fill" color="#00f" size="1.2rem" viewBox="0 0 24 24" :coverage="1"
        style="display: block;margin-left: 5px;" /> -->
      </div>
    </div>
  </span>
</template>
<script>
import { useGoodPostageStore } from '~/stores/goodPost';
import { useGoodPostage, useGuoJia, useProvince } from '@bee-hole/coms';
import {
  onMounted,
  ref,
  computed,
  onBeforeUnmount
} from "@nuxtjs/composition-api";
import {
  SfPrice,
  SfSelect,
  SfIcon
} from '@storefront-ui/vue';
import { EventBus } from '@/plugins/eventBus';
export default {
  name: 'getPostage',
  props: {
    goods: {
      default: null
    },
    sku: {
      default: null
    }
  },
  setup(props, ctx) {
    const postage = ref();
    const goodPostageStore = useGoodPostageStore();
    const { GuoJiaGet, result: countryList } = useGuoJia();
    const { getProvince, result: provinces } = useProvince();
    const { getGoodPostage, result: goodPostRes, error: goodPostErr } = useGoodPostage(props.sku?.skuId);
    const edit = ref(false);
    const countryCode = ref(goodPostageStore.country);
    const proviceCode = ref(goodPostageStore.state);
    const currentCountry = computed(() => {
      if (countryList.value) {
        if (goodPostageStore.country) {
          const country = countryList.value?.find(item => item.simple_speech === goodPostageStore.country);
          return country;
        } else if (postage.value?.post_fee?.country) {
          return countryList.value?.find(item => item.simple_speech === postage.value?.post_fee?.country);
        } else {
          return { name: '' };
        }
      }
    });
    const getPostageData = async (sku) => {
      const dataSku = sku || props.sku;
      const query = { sku_id: dataSku?.skuId, num: dataSku?.num };
      if (countryCode.value) {
        query.country = countryCode.value;
      }
      if (proviceCode.value) {
        query.state = proviceCode.value;
      }
      if (query.sku_id) {
        await getGoodPostage(query);
        postage.value = goodPostRes.value;
      } else {
        postage.value = null;
      }
      return postage.value;
    };
    const changeProvince = (value) => {
      goodPostageStore.setState(value);
      proviceCode.value = value;
      getPostageData();
    };
    const setCountry = (value, init) => {
      countryCode.value = value;
      goodPostageStore.setCountry(value);
      if (!init) {
        goodPostageStore.setState('');
      } else if (provinces.value && provinces.value?.list?.length >= 1) {
        changeProvince(provinces.value?.list?.[0].countries_library_nodes_name);
      }
    };
    const changeCounry = async (value, init) => {
      // console.log('查询' + value + '省份');
      if (value) {
        await getProvince({ country_code: value });
        setCountry(value, init);
        return provinces.value;
      } else {
        return [];
      }
    };
    const currentProvice = computed(() => {
      if (provinces.value?.list) {
        if (goodPostageStore.state) {
          return provinces.value.list?.find(item => item.countries_library_nodes_name === goodPostageStore?.state);
        } else if (postage.value?.post_fee?.state) {
          return provinces.value.list?.find(item => item.countries_library_nodes_name === postage.value?.post_fee?.state);
        } else {
          return { countries_library_nodes_name: '' };
        }
      } else {
        return { countries_library_nodes_name: '' };
      }
    });
    const initData = async (sku) => {
      let currentCountryData = null;
      if (!countryCode.value && countryList.value && countryList.value.length) {
        changeCounry(countryList.value[0].simple_speech, 1);
      }
      if (countryCode.value) {
        currentCountryData = countryList.value?.find(item => item.simple_speech === countryCode.value);
      }
      if (!currentCountryData && countryList.value && countryList.value.length) {
        changeCounry(countryList.value[0].simple_speech, 1);
      } else {
        await changeCounry(countryCode.value, 0);
      }
      await getPostageData(sku);
      // console.log('countryCode.value -------', countryCode.value, postage.value?.post_fee?.country);
      if (!countryCode.value && postage.value?.post_fee?.country) {
        goodPostageStore.setCountry(postage.value?.post_fee?.country);
        countryCode.value = postage.value?.post_fee?.country;
        await changeCounry(countryCode.value, 1);
      }
      // console.log('postage.value?.post_fee?.state', postage.value?.post_fee?.state)
      if (!goodPostageStore?.state && provinces.value) {
        goodPostageStore.setState(postage.value?.post_fee?.state);
        proviceCode.value = postage.value?.post_fee?.state;
      }
    };
    onMounted(async () => {
      EventBus.$on('SkuChange', async (data) => {
        if (data && data.sku && data.sku.skuId) {
          await GuoJiaGet();
          initData(data.sku);
        } else {
          await GuoJiaGet();
        }
      });
    });
    onBeforeUnmount(() => {
      EventBus.$off('SkuChange');
    });
    const changeEdit = () => {
      edit.value = !edit.value;
    };
    return {
      postage,
      currentCountry,
      countryList,
      changeCounry,
      provinceList: computed(() => provinces.value?.list),
      changeProvince,
      countryCode,
      proviceCode,
      currentProvice,
      edit,
      changeEdit,
      goodPostErr
    };
  },
  components: {
    SfPrice,
    SfSelect,
    SfIcon
  }
};
</script>
<style lang="scss">
  .postFeeContext{
    @include for-mobile{
      font-size: 0.8rem;
    }
  }
</style>
